export const iconBoxTabContent = {
  "ic-1": {
    tabTitle: "Online Order and Delivery",
    tabContent:
      "Streamline your ordering experience with secure payments and flexible options: delivery to your door or quick store pickup",
    image: require("../../../assets/images/orderAndDelivery.png"),
  },
  "ic-2": {
    tabTitle: "Brand Marketing",
    tabContent:
      "Your Brand, Your Story, Your Future.  Effortlessly sync updates across your website, social media, and mobile platforms. Share your product catalogs, deals and news with one click to engage customers anytime, anywhere.",
    image: require("../../../assets/images/brandMarketing.png"),
  },
  "ic-3": {
    tabTitle: "Data Driven Insights",
    tabContent:
      "Leverage powerful tools to predict sales, optimize pricing, and forecast inventory. Understand customer behavior and deliver exactly what they need with smart technology.",
    image: require("../../../assets/images/dataDriven.png"),
  },
  "ic-4": {
    tabTitle: "Rewards and Loyalty",
    tabContent: [
      "Turn visitors into regulars with a rewarding experience. Let customers earn points, redeem offers, and track rewards on their phones—while you track what keeps them coming back.",
    ],
    image: require("../../../assets/images/rewardsAndCoupons.png"),
  },
  "ic-5": {
    tabTitle: "Catalog Management",
    tabContent:
      "Update your online shop in seconds—prices, items, and sales with one click. Upload once, and your updates sync seamlessly across your website and mobile app.",
    image: require("../../../assets/images/catalogManagement.png"),
  },
  "ic-6": {
    tabTitle: "QR Code Promotions",
    tabContent:
      "Use QR Code Promotions to easily share your online presence on websites and mobile platforms. Let customers access your digital catalog, place orders, and share feedback by simply scanning a personalized QR code",
    image: require("../../../assets/images/qrCodeScanner.png"),
  },
};

export const mobileSectionContent = [
  {
    title: "Mobile Title 1",
    content:
      "Create amazing motion graphics with an intuitive timeline editor.",
    image: "images/datumart-web/png/iphone-1.png",
  },
  {
    title: "Mobile Title 2",
    content:
      "Render your animation right in the browser without waiting in queues.",
    image: "images/datumart-web/png/iphone-2.png",
  },
  {
    title: "Mobile Title 3",
    content: "Never start from scratch with ever-growing template library.",
    image: "images/datumart-web/png/iphone-1.png",
  },
];

export const whyChooseUs = [
  {
    id: "01",
    whyChooseUsTitle: "Digital Marketing",
    whyChooseUsSubTitle:
      "Our Digital Marketing Creative Support Services help you craft compelling content and campaigns to elevate the digital presence of your brand.",
    image: "images/appImages/digitalMarketing.jpg",
  },
  {
    id: "02",
    whyChooseUsTitle: "AI / ML / Data Science",
    whyChooseUsSubTitle:
      "Our AI, ML, and Data Science support services empower your business with advanced insights, predictive models, and intelligent solutions for data-driven decision-making.",
    image: "images/appImages/dataScience.png",
  },
  {
    id: "03",
    whyChooseUsTitle: "WEB & Mobile App Development",
    whyChooseUsSubTitle:
      "Our Web & Mobile App Development services deliver custom, high-performance solutions that enhance user experience and drive business growth across platforms.",
    image: "images/appImages/appBuild.png",
  },
];

export const whyChooseDatumartData = [
  {
    id: 1,
    header: "750+ Active Users",
    content:
      "Our platform is trusted by over 750+ active users globally, including businesses of all sizes. We are committed to providing exceptional tools and services to help our clients achieve their goals and optimize their operations.",
  },
  {
    id: 2,
    header: "65+ Powerful Features",
    content:
      "Our platform is equipped with 65+ robust features designed to streamline your workflow, enhance customer experience, and drive sales. From advanced catalog and order management to analytics, real-time updates, and customer loyalty tools, we have everything you need to thrive in the competitive digital marketplace.",
  },
  {
    id: 3,
    header: "Machine Learning Models for Business Performance Insights",
    content:
      "Harness the power of AI-driven insights with our machine learning models include: Forecasting - Stay ahead of the game by accurately predicting trends, customer behavior, and seasonal demand. Pricing Optimization - Maximize your revenue with dynamic pricing strategies tailored to your business needs. Customer Lifetime Value (CLTV) - Identify and focus on high-value customers, improving retention and long-term profitability.",
  },
  {
    id: 4,
    header: "Global Reach",
    content:
      "We proudly serve clients across the UK and US, empowering businesses in diverse industries to achieve digital excellence. Our international experience ensures that we understand and adapt to various market dynamics, offering solutions that resonate globally.",
  },
  {
    id: 5,
    header: "Current Enhancements",
    content:
      "Gen AI Assistant for Business Owners : Simplifies marketing with AI-driven tools for creating personalized, high-quality content effortlessly. \n User Chat Assistant: Delivers intuitive product recommendations and instant responses to enhance customer engagement and satisfaction.",
  },
];

export const clientTestimonials = [
  {
    name: "Ashok",
    vendor: "AnjapparUK - EastHam",
    image: "https://i.pravatar.cc/300",
    comment:
      "We are extremely impressed with the comprehensive solutions provided by Datum Growth Solutions. The platform enables us to keep customers engaged through sales while staying connected within the same application. There's no need to learn additional tools to collect feedback, showcase new offers, or highlight arrivals. This simplicity and efficiency have convinced us to onboard our business soon!",
  },
  {
    name: "Maya",
    vendor: "Cholacafe BentonVille - US",
    image: "https://i.pravatar.cc/300",
    comment:
      "As a restaurant owner, I’m delighted with Datumart White label Solutions' supports in promoting our brand and increasing online sales through our signature mobile app. Their catalog management system makes updating our menu effortless, and their responsive customer service ensures quick issue resolution. They’ve seamlessly customized the app to suit our needs, enhancing our operational efficiency. I highly recommend their services for their professionalism, adaptability, and commitment to excellence. Datumart has been a vital partner in driving our digital growth and customer engagement",
  },
  {
    name: "Krishna",
    vendor: "Cholacafe BentonVille - US",
    image: "https://i.pravatar.cc/300",
    comment:
      "As a store manager, I find Datumart web app solution incredibly efficient for managing orders, especially during peak hours. Alerts for new orders and seamless handling of busy times have transformed our operations. Since launching offers, our online sales have increased, and we've even unsubscribed from other aggregators. Offering the same prices as in-store has converted many of our Uber Eats customers to order directly through our app. Handling peak hours and facilitating customer pickups have become effortless, making this platform a game-changer for our business.",
  },
  {
    name: "Baskaran",
    vendor: "Croydon FoodStation - London",
    image: "https://i.pravatar.cc/300",
    comment:
      "As a Londoner, store sales have experienced significant growth, thanks to Datumart Team. Their seamless home delivery solution and transparent subscription model with no hidden costs empower us to offer competitive prices, outperforming other aggregators. By introducing discounts during non-peak hours and rewarding customers with points and coupons, we’ve not only increased store pickups but also built stronger customer loyalty. Datumart’s innovative solutions have truly transformed our business and given us the edge to grow faster than ever!",
  },
  {
    name: "Kumaran",
    vendor: "Account Manager - Croydon FoodStation London",
    image: "https://i.pravatar.cc/300",
    comment:
      "Featuring daily banners and showcasing new arrivals has never been easier since we started using Datumart platform. The intuitive category list helps me plan and organize efficiently, boosting customer engagement. Our customers can now share feedback seamlessly, keeping our store assistants motivated and improving service quality. Managing live orders has become effortless, significantly reducing client wait times and enhancing the overall experience. Datumart’s solutions have been a game-changer for our operations and customer satisfaction!",
  },
];
